import React from 'react';
import type { Attachment } from 'belo-js-sdk';
import type { DefaultBeloChatGenerics } from '../../types/types';

export type UnsupportedAttachmentProps<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = {
  attachment: Attachment<BeloChatGenerics>;
};

export const UnsupportedAttachment = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>({
  attachment,
}: UnsupportedAttachmentProps<BeloChatGenerics>) => (
  <div>
    <div>
      Unsupported attachment type <strong>{attachment.type ?? 'unknown'}</strong>
    </div>
    <code>{JSON.stringify(attachment, null, 4)}</code>;
  </div>
);

export const NullComponent = () => null;
